import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

const FooterStyled = styled(Flexer.Child)`
  border-top: 1px solid var(--grey200);
`;

export default FooterStyled;
